<template>
  <div class="container">
    <div class="banner">
      <img src="https://gengzhi-1315427254.cos.ap-beijing.myqcloud.com/h5/website/banner.png" alt="">
    </div>

    <div class="title">
      <div>供给云</div>
      <span>去中心化的SAAS私域服务云平台</span>
    </div>

    <div class="scroll-container">
      <ul class="scroll-content">
        <li>
          <img src="https://gengzhi-1315427254.cos.ap-beijing.myqcloud.com/h5/website/scroll-card1.png" alt="">
        </li>
        <li>
          <img src="https://gengzhi-1315427254.cos.ap-beijing.myqcloud.com/h5/website/scroll-card2.png" alt="">
        </li>
        <li>
          <img src="https://gengzhi-1315427254.cos.ap-beijing.myqcloud.com/h5/website/scroll-card3.png" alt="">
        </li>
      </ul>
    </div>

    <div class="title">
      <div>供给云，您身边的贴心生意管家</div>
    </div>
    <ul class="card-content">
      <li>
        <img src="https://gengzhi-1315427254.cos.ap-beijing.myqcloud.com/h5/website/card-1.png" alt="">
      </li>
      <li>
        <img src="https://gengzhi-1315427254.cos.ap-beijing.myqcloud.com/h5/website/card-2.png" alt="">
      </li>
      <li>
        <img src="https://gengzhi-1315427254.cos.ap-beijing.myqcloud.com/h5/website/card-3.png" alt="">
      </li>
      <li>
        <img src="https://gengzhi-1315427254.cos.ap-beijing.myqcloud.com/h5/website/card-4.png" alt="">
      </li>
      <li>
        <img src="https://gengzhi-1315427254.cos.ap-beijing.myqcloud.com/h5/website/card-5.png" alt="">
      </li>
      <li>
        <img src="https://gengzhi-1315427254.cos.ap-beijing.myqcloud.com/h5/website/card-6.png" alt="">
      </li>
      <li>
        <img src="https://gengzhi-1315427254.cos.ap-beijing.myqcloud.com/h5/website/card-7.png" alt="">
      </li>
      <li>
        <img src="https://gengzhi-1315427254.cos.ap-beijing.myqcloud.com/h5/website/card-8.png" alt="">
      </li>
      <li>
        <img src="https://gengzhi-1315427254.cos.ap-beijing.myqcloud.com/h5/website/card-9.png" alt="">
      </li>
      <li>
        <img src="https://gengzhi-1315427254.cos.ap-beijing.myqcloud.com/h5/website/card-10.png" alt="">
      </li>
    </ul>

    <div class="title" style="margin: 0 62px;">
      <div>供给云</div>
      <span>以供应链为基础，自动化运营为纽带，为私域SSSA商户赋能</span>
    </div>
    <div class="statistics">
      <ul>
        <li>
          <div>
            <span class="num">100</span>
            <span class="unit">万</span>
          </div>
          <span class="desc">商家信赖之选</span>
        </li>
        <li>
          <div>
            <span class="num">150</span>
            <span class="unit">万</span>
          </div>
          <span class="desc">覆盖行业和类目</span>
        </li>
        <li style="margin-top: 20px;">
          <div>
            <span class="num">200</span>
            <span class="unit">万+</span>
          </div>
          <span class="desc">在售商品数</span>
        </li>
        <li style="margin-top: 20px;">
          <div>
            <span class="num">2000</span>
            <span class="unit">+</span>
          </div>
          <span class="desc">网红K</span>
        </li>
      </ul>
    </div>

    <div class="title">
      <div>提供全行业解决方案</div>
    </div>
    <div class="brands-content">
      <img src="https://gengzhi-1315427254.cos.ap-beijing.myqcloud.com/h5/website/brands.png" alt="">
    </div>

    <div class="system-content">
      <div class="title">
        <div>360°全方位服务体系</div>
      </div>
      <ul class="card-content">
        <li>
          <img src="https://gengzhi-1315427254.cos.ap-beijing.myqcloud.com/h5/website/system-1.png" alt="">
        </li>
        <li>
          <img src="https://gengzhi-1315427254.cos.ap-beijing.myqcloud.com/h5/website/system-2.png" alt="">
        </li>
        <li>
          <img src="https://gengzhi-1315427254.cos.ap-beijing.myqcloud.com/h5/website/system-3.png" alt="">
        </li>
        <li>
          <img src="https://gengzhi-1315427254.cos.ap-beijing.myqcloud.com/h5/website/system-4.png" alt="">
        </li>
      </ul>
    </div>

    <div class="cooperation-content">
      <div class="names">
        <div>合作伙伴</div>
      </div>
      <img src="https://gengzhi-1315427254.cos.ap-beijing.myqcloud.com/h5/website/cooperation.png" alt="">
    </div>

    <div class="footer">
      <div class="footer-top">
        <span>下载供给云APP</span>
        <div>
          <div class="footer-item">
            <img src="https://gengzhi-1315427254.cos.ap-beijing.myqcloud.com/h5/website/ios-qr.png" alt="">
            <div class="text-center">iOS</div>
          </div>
          <div class="footer-item">
            <img src="https://gengzhi-1315427254.cos.ap-beijing.myqcloud.com/h5/website/android-qr.png" alt="">
            <div class="text-center">Android</div>
          </div>
        </div>
      </div>
      <div class="footer-bot">
        Copyright © www.gongjihulian.com, All Rights Reserved.
      </div>
    </div>

  </div>

</template>

<script>
import { onMounted, reactive, toRefs } from "vue";
export default {
  setup() {
    const state = reactive({});

    onMounted(() => {});

    return {
      ...toRefs(state),
    };
  },
};
</script>

<style lang="less" scoped>
.container {
  li {
    list-style: none;
  }
  img {
    width: 100%;
    padding: 0;
    margin: 0;
  }
  .text-center {
    text-align: center;
  }
  color: #2a2d37;
  .banner {
    width: 100%;
  }

  .title {
    text-align: center;
    div {
      font-weight: 600;
      font-size: 24px;
      margin: 30px 0 0;
    }
    span {
      display: block;
      font-weight: 600;
      font-size: 14px;
      color: #535961;
      margin-top: 10px;
    }
  }

  .scroll-container {
    overflow-x: auto;
    white-space: nowrap; 
    width: 100%;
    margin-bottom: 60px;
  }

  .scroll-content {
    margin-left: 5%;
    margin-top: 39px;
  }
  .scroll-content li {
    width: 150px;
    display: inline-block;
    white-space: normal;
    margin-right: 10px;
  }

  .card-content {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 30px 5%;
    li {
      width: 48%;
      margin-bottom: 10px;
    }
  }

  .statistics {
    ul {
      display: flex;
      flex-wrap: wrap;
      padding: 20px 0 20px 11%;
      justify-content: space-between;
      // border: 1px solid red;
    }
    li {
      width: 140px;
      // border: 1px solid red;
      margin-right: 3%;
      // margin-bottom: 30px;
    }
    .num {
      color: #336bf6;
      font-size: 40px;
      font-weight: 600;
    }
    .unit {
      color: #336bf6;
      font-size: 14px;
    }
    .desc {
      font-size: 14px;
      color: #9ca4b0;
    }
  }

  .system-content {
    background: #f8f9fb;
    padding-top: 10px;
  }

  .brands-content {
    padding: 20px 5% 50px;
  }

  .cooperation-content {
    padding: 60px 5% 42px;
    .names {
      font-weight: 600;
      font-size: 24px;
      color: #2a2d37;
      text-align: center;
      padding-bottom: 20px;
    }
  }

  .footer {
    .footer-top {
      background: #2a2d37;
      padding: 40px;
      color: #ffffff;
      span {
        font-weight: 600;
        font-size: 16px;
      }
      img {
        margin-bottom: 8px;
      }
    }
    .footer-bot {
      background: #20232b;
      font-size: 12px;
      color: #535961;
      text-align: center;
      padding: 20px 0;
    }
    .footer-item {
      display: inline-block;
      width: 93px;
      margin-top: 28px;
      margin-right: 20px;
    }
  }
}
</style>
